import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-theme bg-theme-surface px-3 py-2 text-base text-theme-text shadow-sm placeholder:text-theme-muted focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#002FA7] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
